import Vue from 'vue';
import SkyInputFile from './SkyInputFile';

Vue.component('SkyInputFile', SkyInputFile);

export default SkyInputFile;



// WEBPACK FOOTER //
// ./scripts/sky-input-file/index.js